import React, {Fragment, useEffect} from "react";
import errorImg from "../../../assets/images/ket-noi-that-bai.png"

const ErrorPage = ({
   ojCallback
}) => {

    const handleClose = () => {
        if(ojCallback) {
            var urlError = ojCallback.failureCb
            urlError = urlError.replace('%7Bcode%7D', 'CANCEL')
            urlError = urlError.replace('%7Bmessage%7D', 'CANCEL')
            window.location.replace(urlError)
        }

    }

    useEffect(() => {
        if(ojCallback) {
            setTimeout(() => {

            }, 5000)
        }
    })

    return (
        <div className='success-payment'>
            <div className="success-payment--top">
                <img src={errorImg} alt="Gửi lệnh thất bại"/>
                <p>Nằm ngoài phạm vi kết nối</p>
            </div>
            {ojCallback && <button onClick={handleClose} className="btn-close">Đóng</button>}
        </div>
    )
}

export default ErrorPage